import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const CircleCheckIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40 73.3334C58.3333 73.3334 73.3333 58.3334 73.3333 40.0001C73.3333 21.6667 58.3333 6.66675 40 6.66675C21.6667 6.66675 6.66667 21.6667 6.66667 40.0001C6.66667 58.3334 21.6667 73.3334 40 73.3334Z"
        stroke="#028B3D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8333 39.9997L35.2667 49.4331L54.1667 30.5664"
        stroke="#028B3D"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
